import React from "react";

// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

class WorkflowStepsHeader extends React.Component {
  render() {
    return (
      <>
        <div className="header pb-4 pt-7" style={{background: "linear-gradient(to right, #FFFFFF, #4A002B)"}}>
          <Container fluid>
            <div className="header-body">
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default WorkflowStepsHeader;
